import { Box, chakra } from "@chakra-ui/react";

const SignupFormContainer = chakra(Box, {
  baseStyle: {
    minWidth: { base: "full", md: "400px", lg: "560px" },
    paddingTop: { base: "0px", md: "20px" },
  },
});

const StyledSignupHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "18px", md: "24px" },
  },
});
const StyledSignupSubHeading = chakra(Box, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "18px", md: "24px" },
    color: "purple.500",
  },
});

const StyledSignupDescription = chakra(Box, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "10px", md: "14px" },
    mt: "7px",
    color: "primary.grayText",
  },
});

export {
  SignupFormContainer,
  StyledSignupHeading,
  StyledSignupSubHeading,
  StyledSignupDescription,
};
